import { lazy } from 'react'

import type { RouteObject } from 'react-router'

import { getSimulacaoEntryPointConfig } from '@/shared/simulacao-entry-point/simulacao-entry-point.config'

const ListagemEmpreendimentosPage = lazy(() =>
  import('@/features/espelho-de-vendas/chile/pages/listagem-empreendimentos').then((module) => ({
    default: module.EspelhoDeVendasPage,
  })),
)

const EspelhoDeVendasEmpreendimentoPage = lazy(() =>
  import('@/features/espelho-de-vendas/chile/pages/espelho-de-vendas-vertical').then((module) => ({
    default: module.EspelhoDeVendasVerticalPage,
  })),
)

export const chileEspelhoDeVendasRoutes: RouteObject[] = [
  {
    path: 'es-CL/espelho-de-vendas',
    children: [
      {
        index: true,
        element: <ListagemEmpreendimentosPage entryPointConfig={getSimulacaoEntryPointConfig('espelho-de-vendas')} />,
      },
      {
        path: ':idExternoEmpreendimento',
        element: (
          <EspelhoDeVendasEmpreendimentoPage entryPointConfig={getSimulacaoEntryPointConfig('espelho-de-vendas')} />
        ),
      },
    ],
  },
]
